function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Download(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.768 16.303a1 1 0 011 1v2.039c0 2.206-1.795 4-4 4H5c-2.205 0-4-1.794-4-4v-2.04a1 1 0 012 0v2.04c0 1.103.898 2 2 2h13.77c1.102 0 2-.897 2-2v-2.04a1 1 0 011-1zM11.851 1a1 1 0 011 1v13.502l3.27-3.433a.999.999 0 111.448 1.379l-4.993 5.241-.009.01a1.004 1.004 0 01-.02.02l-.007.005-.015.016a1.003 1.003 0 01-.072.06l.087-.076a1.007 1.007 0 01-.152.12l-.025.015a.996.996 0 01-.013.008l-.03.016a.4.4 0 01-.029.016l-.033.015a.992.992 0 01-.029.012l-.03.011a.102.102 0 01-.01.005l-.034.011a.995.995 0 01-.052.015l-.013.003a.108.108 0 01-.01.003l-.067.013a1.002 1.002 0 01-.034.005h-.006a.07.07 0 01-.005.001l-.084.007h-.033c-.04 0-.08-.002-.12-.007l.12.007c-.043 0-.086-.003-.128-.008h-.003l-.04-.007a.995.995 0 01-.058-.011l-.01-.003a.997.997 0 01-.098-.03l-.011-.004a.993.993 0 01-.091-.038l-.03-.016a.992.992 0 01-.104-.064l-.028-.02a.931.931 0 01-.106-.092l-.017-.018-4.992-5.24a.999.999 0 111.448-1.38l3.267 3.43L10.851 2a1 1 0 011-1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoDownload = /*#__PURE__*/React.memo(Download);
export default MemoDownload;